import { inject, Injectable } from '@angular/core';
import { ApiService } from '@letly/services';
import { Observable } from 'rxjs';
import { ApiResponse } from '@letly/models';
import { FiltersModel } from '../models/filters.model';
import { PropertyListRes } from '../models/property-list.res';
import { environment } from '../../../env/environment';

@Injectable({
  providedIn: 'root'
})
export class PropertyListService {

  private apiService = inject(ApiService);

  getProperties(data: Partial<FiltersModel>): Observable<ApiResponse<PropertyListRes>> {
    return this.apiService.get(environment.listingBaseUrl + '/v1/listed-properties', data);
  }
}
